import React from 'react'
import { Table, TableBody, TableContainer, TableHead, TableRow, Theme } from '@mui/material'
import { SxProps } from '@mui/system'

interface TableListContainerProps {
  tableHeadComponents: React.ReactNode
  tableBodyComponents: React.ReactNode
  tableContainerSx: SxProps<Theme>
}

export const TableListContainer: React.FC<TableListContainerProps> = ({
  tableHeadComponents,
  tableBodyComponents,
  tableContainerSx,
}) => {
  return (
    <TableContainer sx={tableContainerSx}>
      <Table stickyHeader aria-label="sticky table">
        <TableHead>
          <TableRow>{tableHeadComponents}</TableRow>
        </TableHead>
        <TableBody>{tableBodyComponents}</TableBody>
      </Table>
    </TableContainer>
  )
}
